export default __webpack_public_path__ + "static/media/FotoReinoBurger.28e3460a.webp";